import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
const { processAlertMessage } = require('../accessibility/accessibilityHelper');

const pdpPrimaryGallery = {
    elements: {
        $document: $(document),
    },

    selectors: {
        carousel: '.js-pdp-primary-gallery-carousel',
        dialog: '#pdp-primary-gallery'
    },

    settings: {
        carouselParameters:
        {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            mousewheel: true,
            keyboard: true,
            initialSlide: 0,
            navigation: {
                nextEl: ".js-pdp-primary-gallery-btn-next",
                prevEl: ".js-pdp-primary-gallery-btn-prev",
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing pdp gallery carousel slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    state: {
        swiper: {
            initialized: false,
            currentSlider: null
        }
    },

    init() {
        this.initEvents();
    },

    initEvents() {
        this.elements.$document.on('dialog:open', this.selectors.dialog, (e, data) => this.initCarousel(e, data));
    },

    initCarousel(e, data) {
        const initialSlide = data.options.initialSlideNumber || '0';
        const currentSlider = this.state.swiper.currentSlider;

        if(currentSlider) {
            currentSlider.slideTo(initialSlide, '0', false);
        } else {
            this.state.swiper.currentSlider = new Swiper(this.selectors.carousel, {
                ...this.settings.carouselParameters,
                initialSlide: initialSlide
            });
        }
    }
};

pdpPrimaryGallery.init();